import API from '@/constant/API';
import {StyledTextField} from '@/styles/CommonStyledComponents';
import axiosInstance from '@/utils/axios';
import {InputAdornment} from '@mui/material';
import {useEffect, useRef} from 'react';
import {useTranslation} from 'react-i18next';
import SendCodeButton from './SendCodeButton';
import PropTypes from "prop-types";

const SendCodeInput = ({
                         autoSend,
                         isMobile,
                         nationCode,
                         action,
                         sign,
                         username,
                         placeholder,
                         value,
                         error,
                         sendCodeEnable = true,
                         size,
                         ...props
                       }) => {
  const {t} = useTranslation();
  const sendCodeBtnRef = useRef();

  useEffect(() => {
    if (autoSend) {
      sendCodeBtnRef.current.startCountdown();
    }
  }, [autoSend]);

  const sendCode = async () => {
    if (!username) return;

    try {
      const params = {
        action, sign,
      };

      if (isMobile) {
        params.nationCode = nationCode;
        params.mobile = username;
      } else {
        params.email = username;
      }

      await axiosInstance.post(isMobile ? API.SEND_MOBILE_CODE :
          // API.SEND_EMAIL_CODE,
          API.LOGIN_GET_CODE,
        params);
      sendCodeBtnRef.current?.startCountdown();
    } catch (error) {
      // ignore
    }
  }

  return (
    <StyledTextField
      placeholder={placeholder}
      required
      value={value}
      error={error}
      size={size || 'small'}
      fullWidth
      {...props}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <SendCodeButton ref={sendCodeBtnRef} enable={sendCodeEnable}
                            btnText={t('get_code')} call={sendCode}/>
          </InputAdornment>
        ),
      }}
    />
  );
};
SendCodeInput.propTypes = {
  autoSend: PropTypes.any,
  isMobile: PropTypes.bool,
  nationCode: PropTypes.string,
  action: PropTypes.string,
  sign: PropTypes.string,
  username: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  error: PropTypes.string,
  sendCodeEnable: PropTypes.bool,
  size: PropTypes.string,
}
export default SendCodeInput;
